import { render } from "./QuestionHistory.vue?vue&type=template&id=f949250e&scoped=true"
import script from "./QuestionHistory.vue?vue&type=script&lang=js"
export * from "./QuestionHistory.vue?vue&type=script&lang=js"

import "./QuestionHistory.vue?vue&type=style&index=0&id=f949250e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f949250e"]])

export default __exports__